<template>
<div>
  <div class="wistia_embed wistia_async_918nf01h87">
    &nbsp;
  </div>

  <div
    id="choose_administrator"
    class="tbk-vid-embed"
  >
    <a
      id="understanding_cecilia"
      class="embedded_video"
      href="#wistia_mlxjz0n71b?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="understanding_fatuma"
      class="embedded_video"
      href="#wistia_linmikgq7s?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="understanding_julia"
      class="embedded_video"
      href="#wistia_3ghwx7sry0?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="understanding_patina"
      class="embedded_video"
      href="#wistia_8rqj2l9f5n?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('918', 0, this.showSelect)

    this.tbk.loadCrossTime('mlx', 114, this.showSelect)
    this.tbk.loadCrossTime('lin', 129, this.showSelect)
    this.tbk.loadCrossTime('3gh', 76, this.showSelect)
    this.tbk.loadCrossTime('8rq', 99, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        mlx: this.tbk.autoPlay,
        lin: this.tbk.autoPlay,
        '3gh': this.tbk.autoPlay,
        '8rq': this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#choose_administrator
  display: none
  a
    text-decoration: none
#understanding_cecilia
  position: absolute
  top: 0
  left: 0
  width: 25%
  height: 100%
#understanding_fatuma
  position: absolute
  top: 0
  left: 25%
  width: 25%
  height: 100%
#understanding_julia
  position: absolute
  top: 0
  left: 50%
  width: 25%
  height: 100%
#understanding_patina
  position: absolute
  top: 0
  left: 75%
  width: 25%
  height: 100%
</style>
